import { PageHero } from "@/components/PageHero";
import { Projects } from "@/components/Projects";
import { Testimonials } from "@/components/Testimonials";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

export default function WhatWeHaveDone() {
  return (
    <>
      <PageHero
        eyebrow="What We Have Done · 03"
        title="Programs we have"
        italic="shaped."
        subtitle="The 4,000-acre New Model Colony in the City of Ontario, the award-winning Mill Creek Regional Wetlands, an 8-school mitigation agreement, and five adopted specific plans across Ontario and Chino totalling more than 2,200 acres."
        image="https://images.pexels.com/photos/9494281/pexels-photo-9494281.jpg"
      />

      <Projects />
      <Testimonials />

      <section className="bg-paper py-20 lg:py-28 border-t border-border">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div>
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Continue</span>
            <h3 className="font-display text-3xl lg:text-5xl text-ink mt-3 leading-tight tracking-[-0.02em]">Start a conversation →</h3>
          </div>
          <Button asChild className="h-12 rounded-none bg-ink text-paper hover:bg-clay mono text-[11px] uppercase tracking-[0.22em] px-6">
            <Link to="/contact-us">
              Contact us <ArrowUpRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>
    </>
  );
}
